import React from 'react'
import renderRoutes from 'core/routes/renderRoutes'

// Components Global
import Window from 'components/Windows/Window'
import { LayoutsTwo, Layouts1, Layouts2 } from 'components/LayoutsTwoResponsive'
import MenuSidebarResponsive from 'components/MenuSidebarResponsive'

// imgs
import titleIcon from '../resources/imgs/admin-title-icon.png'
import AdminAndUserCreateModal from '../components/AdminAndUserCreateModal'


const menuItems = (params) => {
  let path = `/${params.username}/admins`

  return [
    {
      name: 'รายการ',
      title: true
    },
    {
      name: 'ผู้ดูแลระบบ',
      icon: 'public',
      link: `${path}/all/all`,
      searchLinkActive: `${path}/all/`,
    },
    {
      name: 'ถังขยะ',
      icon: 'delete',
      link: `${path}/trash/all`,
      searchLinkActive: `${path}/trash/`
    }
  ]
}


const AdminsMenuContainer = (props) => {
  const { business, location, route, match, history, windowModal, closeWindowModal } = props

  return (
    <Window
      title="ผู้ดูแลระบบ"
      titleIcon={titleIcon}
      windowModal={windowModal}
      closeWindowModal={closeWindowModal}
      history={history}
      linkClose={`/${match.params.username}`}>

      <LayoutsTwo>
        <Layouts1>
          <MenuSidebarResponsive
            btnAddModal={{
              modalId: 'adminAndUserCreateModal',
              text: 'เพิ่มผู้ดูแลระบบ'
            }}
            match={match}
            items={menuItems(match.params)}
          />
        </Layouts1>

        <Layouts2 hideScrollbars>
          { renderRoutes({
            routes: route.routes,
            extraProps: { business },
            location
          }) }
        </Layouts2>
      </LayoutsTwo>

      <AdminAndUserCreateModal {...props} business={business} id="adminAndUserCreateModal" />
    </Window>
  )
}

export default AdminsMenuContainer
